import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import type { ProductType } from "../models/ProductType";
import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";

interface UseTableDataProps {
	onDelete: (productType: ProductType) => void;
}

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: ColDef<ProductType>[] = [
		{
			field: "Name",
			headerName: "Name",
			flex: 2,
			sortable: true,
			filter: true,
		},
		{
			field: "Description",
			headerName: "Description",
			flex: 2,
			sortable: true,
			filter: true,
		},
		{
			field: "TPHGoal",
			headerName: "TPH Goal",
			flex: 0.8,
			valueFormatter: (params: { value: number | null }) =>
				params.value != null ? params.value.toFixed(2) : "",
		},
		{
			field: "Prefix",
			headerName: "Prefix",
			flex: 0.6,
		},
		activeColumnDef<ProductType>(),
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<ProductType>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as ProductType);
								}}
								color="error"
								sx={{ p: 0.25 }}
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
